export const getChartData = ({
  conclusionsPro,
  proCalculationCharts,
  calculation,
}: {
  conclusionsPro: any;
  proCalculationCharts: any;
  calculation: any;
}) => {
  const earlySaleProfit10 =
    proCalculationCharts?.investmetAnalysisChart?.earlySaleProfit?.[10];
  const earlySaleProfit20 =
    proCalculationCharts?.investmetAnalysisChart?.earlySaleProfit?.[20];
  const earlySaleProfit30 =
    proCalculationCharts?.investmetAnalysisChart?.earlySaleProfit?.[30];

  const rentalYield =
    calculation?.rentalYields?.investmentObjectRentalYield?.rentalYield * 100;

  const irr10 = calculation?.investmetAnalysis?.irrByYearCombinedLoan?.[10];
  const irr20 = calculation?.investmetAnalysis?.irrByYearCombinedLoan?.[20];
  const irr30 = calculation?.investmetAnalysis?.irrByYearCombinedLoan?.[30];

  const roi10 = calculation?.investmetAnalysis?.roiByYearCombinedLoan?.[10];
  const roi20 = calculation?.investmetAnalysis?.roiByYearCombinedLoan?.[20];
  const roi30 = calculation?.investmetAnalysis?.roiByYearCombinedLoan?.[30];

  const investmentsAcc10 =
    proCalculationCharts?.investmentAccChart?.investmentAcc?.[10];
  const investmentsAcc20 =
    proCalculationCharts?.investmentAccChart?.investmentAcc?.[20];
  const investmentsAcc30 =
    proCalculationCharts?.investmentAccChart?.investmentAcc?.[30];

  const investorCashFlowAverage10 =
    proCalculationCharts?.taxSavingsAndProfitChart
      ?.investorCashFlowByYearAverage?.[10];
  const investorCashFlowAverage20 =
    proCalculationCharts?.taxSavingsAndProfitChart
      ?.investorCashFlowByYearAverage?.[20];
  const investorCashFlowAverage30 =
    proCalculationCharts?.taxSavingsAndProfitChart
      ?.investorCashFlowByYearAverage?.[30];

  const specialLoan =
    proCalculationCharts?.loansChart?.info?.loans?.[1]?.amount;

  const totalTaxSavings10 =
    proCalculationCharts?.taxSavingsChart?.totalTaxSavings?.[10];
  const totalTaxSavings20 =
    proCalculationCharts?.taxSavingsChart?.totalTaxSavings?.[20];
  const totalTaxSavings30 =
    proCalculationCharts?.taxSavingsChart?.totalTaxSavings?.[30];

  const userScenarioResult = conclusionsPro?.userScenarioResult;
  const rentalYieldVariant =
    calculation?.rentalYields?.investmentObjectRentalYield.conclusionVariant;

  return {
    earlySaleProfit: {
      10: earlySaleProfit10,
      20: earlySaleProfit20,
      30: earlySaleProfit30,
    },
    rentalYield,
    irr: {
      10: irr10,
      20: irr20,
      30: irr30,
    },
    roi: {
      10: roi10,
      20: roi20,
      30: roi30,
    },
    investmentsAcc: {
      10: investmentsAcc10,
      20: investmentsAcc20,
      30: investmentsAcc30,
    },
    investorCashFlowAverage: {
      10: investorCashFlowAverage10,
      20: investorCashFlowAverage20,
      30: investorCashFlowAverage30,
    },
    specialLoan,
    totalTaxSavings: {
      10: totalTaxSavings10,
      20: totalTaxSavings20,
      30: totalTaxSavings30,
    },
    userScenarioResult,
    rentalYieldVariant,
  };
};
